import { defineComponent, onMounted, ref } from 'vue-demi';
import { useNewsStore } from '../../applications/news/composables/news-composable';

export default defineComponent({
	setup() {
		const highlightedNewsTop = ref(null);
		const { currentPage } = useNewsStore();
		onMounted(() => {
			highlightedNewsTop.value.focus();
		});
		return {
			highlightedNewsTop,
			currentPage
		};
	}
});
